import React from 'react'
import { useSelector } from 'react-redux'
function HeaderTitle() {
    const user = useSelector((state) => state.login.user)
    console.log(user)
  return (
    <div className='d-flex align-items-center' style={{ 
      padding: '6px 14px'
    }}>
      <span className="text-dark" style={{ fontSize: '14px' }}>
        <span className="fw-bold">{user.firstName} {user.lastName}</span>
        <span className="text-muted ms-1">({user.email})</span>
      </span>
    </div>
  )
}

export default HeaderTitle